import Api from 'Helpers/api';

const Etsy = {
	connect: async (params) => {
		try {
			const url = params && params.isCallback ? `/etsy/callback${params.search}` : '/etsy';
			const response = await Api.call('get', url);
			return response.data;
		} catch (err) {
			console.log('api response error', err);
			return err;
		}
	},
	getInventory: async () => {
		try {
			const response = await Api.call('get', '/etsy/getInventory');
			return response.data;
		} catch (err) {
			console.log('api response error', err);
			return err;
		}
	},
	getCountries: async () => {
		try {
			const response = await Api.call('get', '/etsy/getCountries');
			return response.data;
		} catch (err) {
			console.log('api response error', err);
			return err;
		}
	},
	getTransactions: async () => {
		try {
			const response = await Api.call('get', '/etsy/getTransactions');
			return response.data;
		} catch (err) {
			console.log('api response error', err);
			return err;
		}
	},
	getOrder: async () => {
		try {
			const response = await Api.call('get', '/etsy/getOrder?orderid=2874563304');
			return response.data;
		} catch (err) {
			console.log('api response error', err);
			return err;
		}
	},
	sentOrder: async (params) => {
		try {
			const response = await Api.call('post', '/etsy/sentorder', params);
			return response.data;
		} catch (err) {
			console.log('api response error', err);
			return { error: err };
		}
	}
};

export default Etsy;
